module.exports = __webpack_public_path__ + "static/media/firefox-logo.d87159f3.svg";